import type { PaperProps } from "@mui/material";
import { Paper, Table, TableContainer } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  withoutColumnBorders?: boolean;
  paperProps?: PaperProps;
  noPaddingInBodyCells?: boolean;
}

const RoundedTable = ({
  withoutColumnBorders,
  paperProps,
  noPaddingInBodyCells,
  children,
}: PropsWithChildren<Props>) => (
  <Paper variant="outlined" {...paperProps}>
    <TableContainer sx={{ borderRadius: "inherit" }}>
      <Table
        sx={(t) => ({
          "& .MuiTableCell-root": {
            py: 1.375,
            borderRight: withoutColumnBorders ? 0 : "1px solid",
            borderColor: t.palette.divider,
            "&:last-child": {
              borderRight: 0,
            },
            "&.MuiTableCell-body": noPaddingInBodyCells ? { px: 0, py: 0 } : {},
          },
          "& .MuiTableRow-root": {
            "&:last-child": {
              td: {
                borderBottom: 0,
              },
            },
          },
        })}
      >
        {children}
      </Table>
    </TableContainer>
  </Paper>
);

export default RoundedTable;
